﻿$.fn.dxCtrlContentDemandeSupport = function custom_dxCtrlContentDemandeSupport(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlcontentdemandesupport dx-ctrl");
        this.createInstance(new cdxCtrlContentDemandeSupport(this, option));
    }
    return this;
}

window.cdxCtrlContentDemandeSupport = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    var $DivDetailTotal = null
    var $DivDetailTicket = null
    var dataTicketMaitre = null
    var jauge = null
    function mConstruit() {
        container.empty();
        jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")
        var $TableTop = $("<table style='width:100%;table-layout:fixed;margin:5px 5px 0 5px;'/>").appendTo(container)
        if (parametre.isMobile) $TableTop.css("margin", "0")
        var $Tr = $("<tr/>").appendTo($TableTop)
        var $Td = $("<td style='width:45px'><i class='fas fa-user-doctor' style='font-size:35px;'></i></td>").appendTo($Tr)
        var $Td = $("<td style='width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;'>Ticket <b>T" + parametre.code_appli.toUpperCase() + option.idSupportTicket + "</b></td>").appendTo($Tr)
        var $Td = $("<td style='width:45px'/>").appendTo($Tr)
        $("<div/>").appendTo($Td).dxCtrlButton({
            icon: "fas fa-window-maximize",
            onClick: function (e) {
                if (container.parent().css("max-width") == "none") {
                    container.parent().css("max-width", "600px")
                } else {
                    container.parent().css("max-width", "")
                }
            }
        })
        var $Td = $("<td style='width:45px'/>").appendTo($Tr)
        $("<div/>").appendTo($Td).dxCtrlButton({
            icon: "fas fa-xmark",
            onClick: function (e) {
                option.onClose()
            }
        })

        $DivDetailTotal = $("<div style='height:calc(100% - " + $TableTop.innerHeight() + "px);padding: 10px 20px 20px 20px;'/>").appendTo(container)
        if (parametre.isMobile) $DivDetailTotal.css("padding", "0")
        resizeObserver.mAdd($TableTop, function () { $DivDetailTotal.css("height", "calc(100% - " + $TableTop.innerHeight() + "px)") })
        jauge.mShow()
        mConstruitTicket()

    }

    var dataTicketMaitre = null
    var isFirstLoad = true
    function mConstruitTicket() {
        dataTicketMaitre = option.bddCtrl.getObjet("support_ticket", option.idSupportTicket).data
        if (!option.isGestionnaire && dataTicketMaitre.lu == 0) {
            dataTicketMaitre.lu = 1
            option.bddCtrl.getObjet(dataTicketMaitre).mSaveChamp("lu")
        }
        option.bddCtrl.mAjaxCall({
            command: "getdetailsupportticket",
            id_support_ticket: option.idSupportTicket,
            annule_envoi_mail: ((option.isGestionnaire && isFirstLoad) ? "1" : "0")
        }, function (data) {
            isFirstLoad = false
            if (option.isGestionnaire) {
                if (parametre.isMobile) {
                    $DivDetailTicket = $DivDetailTotal
                    window.setTimeout(function () {
                        mRempliDetailMessage(data)
                    }, 500)
                } else {
                    var ctrlResize = $("<div style='width:100%;height:100%;'/>").appendTo($DivDetailTotal).dxCtrlSplitterResize2({
                        bddCtrl: option.bddCtrl,
                        context_grid: "splitter_support",
                        withMarge: true,
                        widthLeftInitial: parseInt(container.innerWidth() / 2)
                    }).dxCtrlSplitterResize2("instance")
                    ctrlResize.mConstruitRight(function (contentElement) {
                        $DivDetailTicket = contentElement
                        window.setTimeout(function () {
                            mRempliDetailMessage(data)
                        }, 500)
                    })
                    ctrlResize.mConstruitLeft(function (contentElement) {
                        $("<div style='width:100%;height:100%;'/>").appendTo(contentElement).dxCtrlContentCompteClient({
                            bddCtrl: option.bddCtrl,
                            idCompteClient: data.ticketdetail[0].id_compte_client,
                            idUtilisateurClient: data.ticketdetail[0].id_utilisateur_client
                        })
                    })
                }

            } else {
                $DivDetailTicket = $DivDetailTotal
                if (typeof data.ticketdetail == 'undefined') {
                    mNotify("Le ticket demandé n'existe plus", "warning", 6000)
                    container.remove()
                } else {
                    mRempliDetailMessage(data)
                }
            }
        })
    }

    var dataCreateur = null
    function mRempliDetailMessage(data) {
        option.bddCtrl.mAjaxCall({
            command: "getdatautilisateurcreateursupportticket",
            "id_compte_client": data.ticketdetail[0].id_compte_client,
            "id_utilisateur_client": data.ticketdetail[0].id_utilisateur_client
        }, function (data) {
            dataCreateur = data
            mRempliListTicket()
            jauge.mHide()
        })

        function mRempliListTicket() {
            $DivDetailTicket.empty()
            var $DivCreateur = $("<div style='padding:0 30px 30px 30px;display:none;'/>").appendTo($DivDetailTicket)
            if (parametre.isMobile) $DivCreateur.css("padding", "0")
            if (option.isGestionnaire) {
                //on est sur le gestionnaire
                $DivCreateur.css("display", "")
                $DivCreateur.css("padding-top", "10px")
                var $Table = $("<table style='width:100%'/>").appendTo($DivCreateur)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:60px;' rowspan='2'/>").appendTo($Tr)
                if (dataCreateur.img64.length == 0) {
                    $("<i class='fas fa-user' style='font-size:40px;'/>").appendTo($Td)
                } else {
                    $("<img src='" + dataCreateur.img64 + "' style='width:50px;border-radius:50%;'/>").appendTo($Td)
                }

                var $Td = $("<td style='width:100%;' colspan='2'>CLIENT: " +
                    ((typeof dataCreateur.nom_base == 'undefined' || dataCreateur.nom_base.length == 0) ? "" : "<span style='opacity:0.3'>nom base:</span>" + dataCreateur.nom_base + " &bull; ") +
                    ((typeof dataCreateur.nom_cptcli == 'undefined') ? "" : "<span style='opacity:0.3'>nom:</span>" + dataCreateur.nom_cptcli + " &bull; ") +
                    ((typeof dataCreateur.ville_cptcli == 'undefined' || dataCreateur.ville_cptcli.length == 0) ? "" : "<span style='opacity:0.3'>ville:</span>" + dataCreateur.ville_cptcli + " &bull; ") +
                    ((typeof dataCreateur.site_cptcli == 'undefined' || dataCreateur.site_cptcli.length == 0) ? "" : "<span style='opacity:0.3'>site:" + dataCreateur.site_cptcli + " &bull; ") +
                    ((typeof dataCreateur.nom_contact_cptcli == 'undefined' || dataCreateur.nom_contact_cptcli.length == 0) ? "" : "<span style='opacity:0.3'>nom_contact:</span>" + dataCreateur.nom_contact_cptcli + " &bull; ") +
                    ((typeof dataCreateur.prenom_contact_cptcli == 'undefined' || dataCreateur.prenom_contact_cptcli.length == 0) ? "" : "<span style='opacity:0.3'>prenom_contact:</span>" + dataCreateur.prenom_contact_cptcli + " &bull; ") +
                    ((typeof dataCreateur.tel_cptcli == 'undefined' || dataCreateur.tel_cptcli.length == 0) ? "" : "<span style='opacity:0.3'>tel:</span>" + dataCreateur.tel_cptcli + " &bull; ") +
                    ((typeof dataCreateur.mob_cptcli == 'undefined' || dataCreateur.mob_cptcli.length == 0) ? "" : "<span style='opacity:0.3'>mobile:</span>" + dataCreateur.mob_cptcli + " &bull; ") +
                    "</td>").appendTo($Tr)

                var $Td = $("<td style='width:1px;padding-left:10px;' rowspan='2'></td>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlButton({
                    icon: "fas fa-certificate",
                    hint: "Créer un nouveau ticket pour cette utilisateur",
                    onClick: function (e) {
                        option.onDemandeNewSupportGestionnaire(data.ticketdetail[0].id_compte_client, data.ticketdetail[0].id_utilisateur_client)
                    }
                })

                var $Td = $("<td style='width:1px;padding-left:10px;' rowspan='2'></td>").appendTo($Tr)
                if (data.ticketdetail[0].resolue == 0) {
                    $("<div/>").appendTo($Td).dxCtrlButton({
                        text: "Résoudre",
                        width: "100%",
                        onClick: function (e) {
                            dataTicketMaitre.resolue = 1
                            option.bddCtrl.getObjet(dataTicketMaitre).mSaveChamp("resolue")
                            option.onClose()
                        }
                    })
                    $("<br/>").appendTo($Td)
                }
                if (data.ticketdetail[0].ouvert == 0) {
                    $("<div/>").appendTo($Td).dxCtrlButton({
                        text: "Ouvrir",
                        width: "100%",
                        onClick: function (e) {
                            dataTicketMaitre.ouvert = 1
                            option.bddCtrl.getObjet(dataTicketMaitre).mSaveChamp("ouvert")
                            option.onClose()
                        }
                    })
                } else {
                    $("<div/>").appendTo($Td).dxCtrlButton({
                        text: "Fermer",
                        width: "100%",
                        onClick: function (e) {
                            dataTicketMaitre.ouvert = 0
                            option.bddCtrl.getObjet(dataTicketMaitre).mSaveChamp("ouvert")
                            option.onClose()
                        }
                    })
                }
            }

            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:100%;'>&nbsp;" + ((data.ticketdetail[0].id_utilisateur_client == "0") ? "CPTCLI" : "UTI") + " &bull; " + dataCreateur.lib + "</td>").appendTo($Tr)


            dxScroll = $("<div style='height:calc(100% - " + ($DivCreateur.innerHeight() + ((option.isGestionnaire) ? 20 : 0)) + "px);'/>").appendTo($DivDetailTicket).dxScrollView({}).dxScrollView("instance")
            dxScroll.content().css("padding-right", "6px")
            data.ticketdetail.forEach(function (ticket, idx) {
                if (idx == 0) {
                    //Entete
                    var $Div = $("<div style='padding-bottom:20px;'/>").appendTo(dxScroll.content())
                    var $TableObjet = $("<table style='width:100%'/>").appendTo($Div)
                    var $TrObjet = $("<tr/>").appendTo($TableObjet)
                    var $TdObjet = $("<td style='width:100%'/>").appendTo($TrObjet)
                    if (option.isGestionnaire) {
                        $("<div/>").appendTo($TdObjet).dxCtrlTextBox({
                            labelMode: 'floating',
                            label: "Objet",
                            value: ticket.objet,
                            onValueChanged: function (e) {
                                ticket.objet = ((e.value) ? e.value : "")
                                option.bddCtrl.getObjet(ticket).mSaveChamp("objet")
                            }
                        })
                    } else {
                        $("<div style='font-size:140%;font-weight:bold;padding:5px;'><b>" + parametre.entete_ticket_support + "-" + ticket.id_support_ticket + "</b> &bull; " + ((ticket.objet == null) ? "" : ticket.objet) + "</div>").appendTo($TdObjet)
                    }
                    var $TdStatut = $("<td style='width:1px;white-space:nowrap;padding-left:10px;'/>").appendTo($TrObjet)
                    if (ticket.ouvert == 1) {
                        $("<div style='background-color:red;border-radius:5px;padding:5px;margin:2px;'>OUVERT</div>").appendTo($TdStatut);
                    } else {
                        $("<div style='background-color:green;border-radius:5px;padding:5px;margin:2px;'>FERME</div>").appendTo($TdStatut);
                    }
                    if (ticket.resolue == 1) {
                        $("<div style='background-color:orange;border-radius:5px;padding:5px;margin:2px;'>RESOLUE</div>").appendTo($TdStatut);
                    }


                    $("<div style='font-size:70%;padding:0 5px;' title='" + ticket.dcr.toFrenchDateTime() + "'>Créé " + ticket.dcr.toDateIlya() + "</div>").appendTo($Div)
                    var $DivContent = $("<div style='padding:15px;margin:10px;border:" + theme.border + ";'>" + ticket.html + "</div>").appendTo($Div)
                    $DivContent.find("img").css("max-width", "100%")
                    $DivContent.find("img").on("click", function (e) {
                        $("<div style='height:100%;width:100%'/>").appendTo("body").dxCtrlPopupImgEdit({
                            bddCtrl: option.bddCtrl,
                            value: $(this).attr("src"),
                            readonly: true
                        });
                    })

                    if (typeof ticket.lstfile != 'undefined' && ticket.lstfile.length > 0) {
                        dxCtrlFicTab = $("<div style='width:100%;padding-top:5px;'/>").appendTo($DivContent).dxCtrlFichier2Document({
                            bddCtrl: option.bddCtrl,
                            dataSource: ticket.lstfile,
                            readOnly: true
                        }).dxCtrlFichier2Document("instance")
                    }
                } else {
                    //reponses
                    var $Div = $("<div style='padding:25px 20px 25px 60px;'/>").appendTo(dxScroll.content())
                    if (parametre.isMobile) $Div.css("padding", "0")
                    if (ticket.id_utilisateur_gest != null) {
                        if (ticket.canceled == "1") {
                            if (option.isGestionnaire) {
                                $Div.css({
                                    opacity: 0.5,
                                    "text-decoration": "line-through",
                                    color: "red"
                                })
                                $Div.attr("title", "Réponse gestionnaire annulée<br/>Cette réponse ne sera pas visible pour l'utilisateur")
                            } else {
                                $Div.css("display", "none")
                            }
                        } else if (ticket.envoi_mail == "0") {
                            if (option.isGestionnaire) {
                                $Div.css({
                                    opacity: 0.5,
                                    "text-decoration": "line-through",
                                    color: "orange"
                                })
                                $Div.attr("title", "Réponse gestionnaire non encore signalé par mail à l'utilisateur<br/>Cette réponse ne sera pas visible pour l'utilisateur tant que le mail n'aura pas été envoyé")
                            } else {
                                $Div.css("display", "none")
                            }
                        }
                    }
                    var $Table = $("<table/>").appendTo($Div)
                    var $Tr1 = $("<tr/>").appendTo($Table)
                    var $TdUtiLeft = $("<td style='vertical-align:top;min-width:66px;padding-right:26px;' rowSpan='2'/>").appendTo($Tr1)
                    var $TdLibUti = $("<td style='width:100%;font-size:80%;font-style:italic;line-height:0.8;border-bottom:" + theme.border + ";padding-bottom:5px;margin-bottom:5px;'/>").appendTo($Tr1)
                    var $Tr2 = $("<tr/>").appendTo($Table)
                    var $TdDetail = $("<td style='width:100%;vertical-align:top;'/>").appendTo($Tr2)
                    var $TdFile = null
                    if (typeof ticket.lstfile != 'undefined' && ticket.lstfile.length > 0) {
                        var $Tr3 = $("<tr/>").appendTo($Table)
                        $TdFile = $("<td style='width:100%;vertical-align:top;border-bottom:" + theme.border + ";'/>").appendTo($Tr3)
                        $TdUtiLeft.attr("rowspan", "3")
                    } else {
                        var $Tr3 = $("<tr/>").appendTo($Table)
                        $("<td style='width:100%;vertical-align:top;border-bottom:" + theme.border + ";padding-bottom:5px;'/>").appendTo($Tr3)
                        $TdUtiLeft.attr("rowspan", "3")
                    }


                    $TdLibUti.css("text-align", "left")
                    if (ticket.id_utilisateur_gest != null) {
                        //reponse assistance
                        var objUti = option.bddCtrl.getObjet("utilisateur", ticket.id_utilisateur_gest)
                        if (!option.bddCtrl.isAuthentified()) {
                            $("<img style='width:100%' src='" + parametre.img + "'/>").appendTo($TdUtiLeft)
                        } else {
                            $("<div style='width:100%;height:40px;border-radius:50%;'/>").appendTo($TdUtiLeft).dxCtrlImgSimpleStrConUti({
                                bddCtrl: option.bddCtrl,
                                idTable: objUti.mGetTable().id_table,
                                id: ticket.id_utilisateur_gest,
                                text: objUti.mGetLib1()
                            })
                        }
                        $TdLibUti.html("<span style='opacity:0.3;'>SUPPORT &bull; " + objUti.mGetLib1() + " &bull; <span title='" + ticket.dcr.toFrenchDateTime() + "'>" + ticket.dcr.toDateIlya() + "</span></span>")
                    } else {
                        //question utilisateur
                        if (dataCreateur.img64.length == 0) {
                            $("<div style='border-radius:50%;background-color:" + theme.backgroundcolorTooltip + ";padding:5px;overflow:hidden;'><i class='fas fa-user' style='font-size:40px;'/></div>").appendTo($TdUtiLeft)
                        } else {
                            $("<img src='" + dataCreateur.img64 + "' style='width:50px;border-radius:50%;'/>").appendTo($TdUtiLeft)
                        }
                        $TdLibUti.html("<span style='opacity:0.3;'>" + dataCreateur.lib + " &bull; <span title='" + ticket.dcr.toFrenchDateTime() + "'>" + ticket.dcr.toDateIlya() + "</span></span>")
                    }

                    $TdDetail.html(ticket.html)
                    $TdDetail.find("img").css("max-width", "100%")
                    $TdDetail.find("img").on("click", function (e) {
                        $("<div style='height:100%;width:100%'/>").appendTo("body").dxCtrlPopupImgEdit({
                            bddCtrl: option.bddCtrl,
                            value: $(this).attr("src"),
                            readonly: true
                        });
                    })

                    if (typeof ticket.lstfile != 'undefined' && ticket.lstfile.length > 0) {
                        $("<div style='width:100%;padding-top:5px;'/>").appendTo($TdFile).dxCtrlFichier2Document({
                            bddCtrl: option.bddCtrl,
                            dataSource: ticket.lstfile,
                            readOnly: true
                        }).dxCtrlFichier2Document("instance")
                    }


                    if (option.isGestionnaire) {
                        $("<div/>").appendTo($TdUtiLeft).dxCtrlButton({
                            icon: 'fas fa-trash-alt',
                            onClick: function (e) {
                                //option.jauge.mShow()
                                option.bddCtrl.getObjet(ticket).mDelDataDefinitif(function (data) {
                                    mConstruit()
                                    //option.jauge.mHide()
                                })
                            }
                        })
                        if (ticket.id_utilisateur_gest != null) {
                            if (ticket.envoi_mail == "0") {
                                if (option.isGestionnaire) {
                                    $("<div/>").appendTo($TdUtiLeft).dxCtrlButton({
                                        icon: 'fas fa-right-from-bracket',
                                        hint: "Ce ticket n'est pas envoyé, forcer l'envoi du ticket",
                                        onClick: function (e) {
                                            ticket.force_envoi = "1"
                                            ticket.envoi_mail = "1"
                                            option.bddCtrl.getObjet(ticket).mSaveChamp("force_envoi")
                                            mRempliListTicket()
                                        }
                                    })
                                }
                            }
                        }
                        if (ticket.canceled == "1") {
                            $("<div/>").appendTo($TdUtiLeft).dxCtrlButton({
                                icon: 'fas fa-copy',
                                hint: "Copier le html de la réponse",
                                onClick: function (e) {
                                    e.component.option("disabled", true)
                                    option.bddCtrl.mAjaxCall({ command: "dupliksupportticketreponsegestionnaire", id_support_ticket: ticket.id_support_ticket }, function (data) {
                                        mConstruit()
                                    })
                                }
                            })
                        }
                    }
                }
            })

            $DivNewComment = $("<div style='padding:25px 20px 0px 60px;'/>").appendTo(dxScroll.content())
            if (parametre.isMobile) $DivNewComment.css("padding", "0")
            mRempliDisplayCommentaire()

            //option.onContentReady()
            window.setTimeout(function () { dxScroll.scrollTo(99999) }, 200)
        }

    }

    var $TdHtmlNew = null
    function mRempliDisplayCommentaire() {
        $DivNewComment.empty()
        if (!option.isGestionnaire && option.idUtilisateurClient != dataTicketMaitre.id_utilisateur_client) {
            return
        }
        var $Table = $("<table/>").appendTo($DivNewComment)
        var $Tr = $("<tr/>").appendTo($Table)
        var $TdUti = $("<td style='width:50px;vertical-align:top;padding-right:10px;'/>")
        $TdHtmlNew = $("<td style='width:100%;padding:5px;cursor:pointer;border:" + theme.border + ";background-color:" + theme.backgroundcolorTooltip + ";' class='state-hover'>Saisissez un nouveau commentaire</td>")
        $TdHtmlNew.on("click", function (e) {
            $TdHtmlNew.off("click")
            $TdHtmlNew.removeClass("state-hover")
            mRempliSaisieCommentaire()
            if ($TdResolue) $TdResolue.remove()
        })
        $TdUti.appendTo($Tr)
        $TdHtmlNew.appendTo($Tr)
        var objUti = null
        if (option.isGestionnaire) {
            //on est  l'environnement gestionnaire
            objUti = option.bddCtrl.getObjet("utilisateur", option.bddCtrl.utiCourant.id_utilisateur)
            $("<div style='width:40px;height:40px;border-radius:50%;'/>").appendTo($TdUti).dxCtrlImgSimpleStrConUti({
                bddCtrl: option.bddCtrl,
                idTable: objUti.mGetTable().id_table,
                id: objUti.data.id_utilisateur,
                text: objUti.mGetLib1()
            })
        } else {
            //on est sur un client
            if (dataCreateur.img64.length == 0) {
                $("<div style='border-radius:50%;background-color:" + theme.backgroundcolorTooltip + ";padding:5px;overflow:hidden;'><i class='fas fa-user' style='font-size:40px;'/></div>").appendTo($TdUti)
            } else {
                $("<img src='" + dataCreateur.img64 + "' style='width:50px;border-radius:50%;'/>").appendTo($TdUti)
            }
        }
        var $TdResolue = null
        if (dataTicketMaitre.resolue == "0") {
            $TdResolue = $("<td style='width:1px;padding-left:5px;'/>").appendTo($Tr)
            var dx = $("<div/>").appendTo($TdResolue).dxCtrlButton({
                text: "Résoudre",
                onClick: function (e) {
                    dataTicketMaitre.resolue = "1"
                    option.bddCtrl.getObjet(dataTicketMaitre).mSave()
                    $TdResolue.remove()
                    mConstruit()
                }
            })
        }

    }

    var dxContentEmailBase = null
    var dataTicketNew = null
    function mRempliSaisieCommentaire() {
        //option.jauge.mShow()
        $TdHtmlNew.empty()
        var $DivHtml = $("<div style='display:none;min-height:400px;'/>").appendTo($TdHtmlNew)
        //$DivHtml.fadeIn(1000)
        $DivHtml.show()
        var jauge = $("<div/>").appendTo($TdHtmlNew).dxCtrlJauge({}).dxCtrlJauge("instance")
        dataTicketNew = option.bddCtrl.getObjet("support_ticket").mGetNewData()
        dataTicketNew.id_support_ticket_parent = dataTicketMaitre.id_support_ticket

        dataTicketNew.id_compte_client = dataTicketMaitre.id_compte_client
        //if (option.isGestionnaire) {
        //    //on est sur le gestionnaire
        dataTicketNew.id_utilisateur_gest = option.idUtilisateurGest
        //} else {
        dataTicketNew.id_utilisateur_client = option.idUtilisateurClient
        //}
        //option.bddCtrl.getObjet(dataTicketNew).mSave(function (data) {
        //window.setTimeout(function () {
        dxContentEmailBase = $("<div style='width:100%;height:400px;'/>").appendTo($DivHtml).dxCtrlContentEmailBase({
            bddCtrl: option.bddCtrl,
            labelObjet: "Objet de votre ticket",
            objetVisible: false,
            readOnly: false,
            data: dataTicketNew,
            saveAuto: false,
            allowAssistant: false,
            allowMiseEnPage: false,
            allowMenu: false,
            allowTag: false,
            allowFullScreen: false,
            allowShowMessageNavigateur: false,
            removeMenuFont: false,
            hideToolbarPrevi: true,
            showOnlyUploadMachine: true,
            onContentReady: function (component) {
                //option.jauge.mHide()
                dxScroll.scrollTo(99999)
                component.focus()
            }
        }).dxCtrlContentEmailBase("instance")

        var $Table = $("<table/>").appendTo($DivHtml)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
        $("<div/>").appendTo($Td).dxCtrlButton({
            text: "Annuler",
            onClick: function (e) {
                jauge.mShow()
                option.bddCtrl.getObjet(dataTicketNew).mDelDataDefinitif(function () {
                    dxContentEmailBase = null
                    dataTicketNew = null
                    mRempliDisplayCommentaire()
                    jauge.mHide()
                })
            }
        })
        if (!option.isGestionnaire) {
            var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
            $("<div/>").appendTo($Td).dxCtrlButton({
                text: "Résoudre",
                txtTooltip: "Si la réponse du support a résolué votre problème,<br/>vous pouvez le signaler aux support.<br/><br/>Cela validera votre saisie en résolvant votre ticket<br/><br/>Vous pourrez à tout moment revenir sur ce ticket<br/>si vous désirez le compléter.",
                onClick: function (e) {
                    mSaveCommentaire("1")
                }
            })
        }
        var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
        var $Td = $("<td style='width:1px;'/>").appendTo($Tr)
        $("<div/>").appendTo($Td).dxCtrlButton({
            text: "Enregistrer",
            onClick: function (e) {
                mSaveCommentaire()
            }
        })
        //}, 1000)
        //})

        function mSaveCommentaire(resolue) {
            jauge.mShow()
            if (typeof resolue != 'undefined') { dataTicketMaitre.resolue = resolue } else { dataTicketMaitre.resolue = 0 }
            if (dataTicketMaitre.ouvert != 1) {
                dataTicketMaitre.ouvert = 1
            }
            //if (typeof resolue == 'undefined') dataTicketMaitre.resolue = 0
            //if (option.isGestionnaire) dataTicketMaitre.lu=0
            dxContentEmailBase.mSaveAuto(function () {
                dataTicketNew.tempo = '0'
                option.bddCtrl.getObjet(dataTicketNew).mSaveChamp("tempo", function () {
                    option.bddCtrl.getObjet(dataTicketMaitre).mSave()
                    mConstruit()
                    jauge.mHide()
                })
            })
        }

    }

    this.element = function () { return container }

    mConstruit();

}